const tokens = {
  "aspectRatios.square": {
    "value": "1 / 1",
    "variable": "var(--aspect-ratios-square)"
  },
  "aspectRatios.landscape": {
    "value": "4 / 3",
    "variable": "var(--aspect-ratios-landscape)"
  },
  "aspectRatios.portrait": {
    "value": "3 / 4",
    "variable": "var(--aspect-ratios-portrait)"
  },
  "aspectRatios.wide": {
    "value": "16 / 9",
    "variable": "var(--aspect-ratios-wide)"
  },
  "aspectRatios.ultrawide": {
    "value": "18 / 5",
    "variable": "var(--aspect-ratios-ultrawide)"
  },
  "aspectRatios.golden": {
    "value": "1.618 / 1",
    "variable": "var(--aspect-ratios-golden)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--easings-default)"
  },
  "easings.linear": {
    "value": "linear",
    "variable": "var(--easings-linear)"
  },
  "easings.in": {
    "value": "cubic-bezier(0.4, 0, 1, 1)",
    "variable": "var(--easings-in)"
  },
  "easings.out": {
    "value": "cubic-bezier(0, 0, 0.2, 1)",
    "variable": "var(--easings-out)"
  },
  "easings.in-out": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--easings-in-out)"
  },
  "fontWeights.thin": {
    "value": "100",
    "variable": "var(--font-weights-thin)"
  },
  "fontWeights.extralight": {
    "value": "200",
    "variable": "var(--font-weights-extralight)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--font-weights-light)"
  },
  "fontWeights.normal": {
    "value": "400",
    "variable": "var(--font-weights-normal)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--font-weights-medium)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--font-weights-bold)"
  },
  "fontWeights.extrabold": {
    "value": "800",
    "variable": "var(--font-weights-extrabold)"
  },
  "fontWeights.black": {
    "value": "900",
    "variable": "var(--font-weights-black)"
  },
  "lineHeights.none": {
    "value": "1",
    "variable": "var(--line-heights-none)"
  },
  "lineHeights.tight": {
    "value": "1.25",
    "variable": "var(--line-heights-tight)"
  },
  "lineHeights.snug": {
    "value": "1.375",
    "variable": "var(--line-heights-snug)"
  },
  "lineHeights.normal": {
    "value": "1.5",
    "variable": "var(--line-heights-normal)"
  },
  "lineHeights.relaxed": {
    "value": "1.625",
    "variable": "var(--line-heights-relaxed)"
  },
  "lineHeights.loose": {
    "value": "2",
    "variable": "var(--line-heights-loose)"
  },
  "letterSpacings.tighter": {
    "value": "-0.05em",
    "variable": "var(--letter-spacings-tighter)"
  },
  "letterSpacings.tight": {
    "value": "-0.025em",
    "variable": "var(--letter-spacings-tight)"
  },
  "letterSpacings.normal": {
    "value": "0em",
    "variable": "var(--letter-spacings-normal)"
  },
  "letterSpacings.wide": {
    "value": "0.025em",
    "variable": "var(--letter-spacings-wide)"
  },
  "letterSpacings.wider": {
    "value": "0.05em",
    "variable": "var(--letter-spacings-wider)"
  },
  "letterSpacings.widest": {
    "value": "0.1em",
    "variable": "var(--letter-spacings-widest)"
  },
  "fontSizes.2xs": {
    "value": "0.5rem",
    "variable": "var(--font-sizes-2xs)"
  },
  "fontSizes.xs": {
    "value": "0.75rem",
    "variable": "var(--font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "0.875rem",
    "variable": "var(--font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "1rem",
    "variable": "var(--font-sizes-md)"
  },
  "fontSizes.lg": {
    "value": "1.125rem",
    "variable": "var(--font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "1.25rem",
    "variable": "var(--font-sizes-xl)"
  },
  "fontSizes.2xl": {
    "value": "1.5rem",
    "variable": "var(--font-sizes-2xl)"
  },
  "fontSizes.3xl": {
    "value": "1.875rem",
    "variable": "var(--font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    "value": "2.25rem",
    "variable": "var(--font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    "value": "3rem",
    "variable": "var(--font-sizes-5xl)"
  },
  "fontSizes.6xl": {
    "value": "3.75rem",
    "variable": "var(--font-sizes-6xl)"
  },
  "fontSizes.7xl": {
    "value": "4.5rem",
    "variable": "var(--font-sizes-7xl)"
  },
  "fontSizes.8xl": {
    "value": "6rem",
    "variable": "var(--font-sizes-8xl)"
  },
  "fontSizes.9xl": {
    "value": "8rem",
    "variable": "var(--font-sizes-9xl)"
  },
  "shadows.2xs": {
    "value": "0 1px rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-2xs)"
  },
  "shadows.xs": {
    "value": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-xs)"
  },
  "shadows.sm": {
    "value": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    "variable": "var(--shadows-sm)"
  },
  "shadows.md": {
    "value": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    "variable": "var(--shadows-md)"
  },
  "shadows.lg": {
    "value": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    "variable": "var(--shadows-lg)"
  },
  "shadows.xl": {
    "value": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    "variable": "var(--shadows-xl)"
  },
  "shadows.2xl": {
    "value": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    "variable": "var(--shadows-2xl)"
  },
  "shadows.inset-2xs": {
    "value": "inset 0 1px rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-inset-2xs)"
  },
  "shadows.inset-xs": {
    "value": "inset 0 1px 1px rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-inset-xs)"
  },
  "shadows.inset-sm": {
    "value": "inset 0 2px 4px rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-inset-sm)"
  },
  "blurs.xs": {
    "value": "4px",
    "variable": "var(--blurs-xs)"
  },
  "blurs.sm": {
    "value": "8px",
    "variable": "var(--blurs-sm)"
  },
  "blurs.md": {
    "value": "12px",
    "variable": "var(--blurs-md)"
  },
  "blurs.lg": {
    "value": "16px",
    "variable": "var(--blurs-lg)"
  },
  "blurs.xl": {
    "value": "24px",
    "variable": "var(--blurs-xl)"
  },
  "blurs.2xl": {
    "value": "40px",
    "variable": "var(--blurs-2xl)"
  },
  "blurs.3xl": {
    "value": "64px",
    "variable": "var(--blurs-3xl)"
  },
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--animations-spin)"
  },
  "animations.ping": {
    "value": "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
    "variable": "var(--animations-ping)"
  },
  "animations.pulse": {
    "value": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    "variable": "var(--animations-pulse)"
  },
  "animations.bounce": {
    "value": "bounce 1s infinite",
    "variable": "var(--animations-bounce)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--sizes-0)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--sizes-1)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--sizes-2)"
  },
  "sizes.3": {
    "value": "1rem",
    "variable": "var(--sizes-3)"
  },
  "sizes.4": {
    "value": "1.5rem",
    "variable": "var(--sizes-4)"
  },
  "sizes.5": {
    "value": "2rem",
    "variable": "var(--sizes-5)"
  },
  "sizes.6": {
    "value": "3rem",
    "variable": "var(--sizes-6)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--sizes-7)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--sizes-8)"
  },
  "sizes.9": {
    "value": "2.25rem",
    "variable": "var(--sizes-9)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--sizes-10)"
  },
  "sizes.11": {
    "value": "2.75rem",
    "variable": "var(--sizes-11)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--sizes-12)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--sizes-14)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--sizes-16)"
  },
  "sizes.20": {
    "value": "5rem",
    "variable": "var(--sizes-20)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--sizes-24)"
  },
  "sizes.28": {
    "value": "7rem",
    "variable": "var(--sizes-28)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--sizes-32)"
  },
  "sizes.36": {
    "value": "9rem",
    "variable": "var(--sizes-36)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--sizes-40)"
  },
  "sizes.44": {
    "value": "11rem",
    "variable": "var(--sizes-44)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--sizes-48)"
  },
  "sizes.52": {
    "value": "13rem",
    "variable": "var(--sizes-52)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--sizes-56)"
  },
  "sizes.60": {
    "value": "15rem",
    "variable": "var(--sizes-60)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--sizes-64)"
  },
  "sizes.72": {
    "value": "18rem",
    "variable": "var(--sizes-72)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--sizes-80)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--sizes-96)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--sizes-0\\.5)"
  },
  "sizes.xs": {
    "value": "20rem",
    "variable": "var(--sizes-xs)"
  },
  "sizes.sm": {
    "value": "24rem",
    "variable": "var(--sizes-sm)"
  },
  "sizes.md": {
    "value": "28rem",
    "variable": "var(--sizes-md)"
  },
  "sizes.lg": {
    "value": "32rem",
    "variable": "var(--sizes-lg)"
  },
  "sizes.xl": {
    "value": "36rem",
    "variable": "var(--sizes-xl)"
  },
  "sizes.2xl": {
    "value": "42rem",
    "variable": "var(--sizes-2xl)"
  },
  "sizes.3xl": {
    "value": "48rem",
    "variable": "var(--sizes-3xl)"
  },
  "sizes.4xl": {
    "value": "56rem",
    "variable": "var(--sizes-4xl)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--sizes-5xl)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--sizes-6xl)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--sizes-7xl)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--sizes-8xl)"
  },
  "sizes.prose": {
    "value": "65ch",
    "variable": "var(--sizes-prose)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--sizes-min)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--sizes-max)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--sizes-fit)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--sizes-1\\.5)"
  },
  "sizes.2.5": {
    "value": "0.75rem",
    "variable": "var(--sizes-2\\.5)"
  },
  "sizes.3.5": {
    "value": "1.25rem",
    "variable": "var(--sizes-3\\.5)"
  },
  "sizes.4.5": {
    "value": "1.75rem",
    "variable": "var(--sizes-4\\.5)"
  },
  "sizes.5.5": {
    "value": "2.5rem",
    "variable": "var(--sizes-5\\.5)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--sizes-full)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1536px",
    "variable": "var(--sizes-breakpoint-2xl)"
  },
  "sizes.breakpoint-sm": {
    "value": "576px",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "992px",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1200px",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--spacing-0)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--spacing-1)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--spacing-2)"
  },
  "spacing.3": {
    "value": "1rem",
    "variable": "var(--spacing-3)"
  },
  "spacing.4": {
    "value": "1.5rem",
    "variable": "var(--spacing-4)"
  },
  "spacing.5": {
    "value": "2rem",
    "variable": "var(--spacing-5)"
  },
  "spacing.6": {
    "value": "3rem",
    "variable": "var(--spacing-6)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--spacing-7)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--spacing-8)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--spacing-9)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--spacing-10)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--spacing-11)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--spacing-12)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--spacing-14)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--spacing-16)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--spacing-20)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--spacing-24)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--spacing-28)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--spacing-32)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--spacing-36)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--spacing-40)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--spacing-44)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--spacing-48)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--spacing-52)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--spacing-56)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--spacing-60)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--spacing-64)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--spacing-72)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--spacing-80)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--spacing-96)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": "0.75rem",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.3.5": {
    "value": "1.25rem",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.4.5": {
    "value": "1.75rem",
    "variable": "var(--spacing-4\\.5)"
  },
  "spacing.5.5": {
    "value": "2.5rem",
    "variable": "var(--spacing-5\\.5)"
  },
  "spacing.full": {
    "value": "100%",
    "variable": "var(--spacing-full)"
  },
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--colors-current)"
  },
  "colors.black": {
    "value": "#000",
    "variable": "var(--colors-black)"
  },
  "colors.white": {
    "value": "#fff",
    "variable": "var(--colors-white)"
  },
  "colors.rose.50": {
    "value": "#fff1f2",
    "variable": "var(--colors-rose-50)"
  },
  "colors.rose.100": {
    "value": "#ffe4e6",
    "variable": "var(--colors-rose-100)"
  },
  "colors.rose.200": {
    "value": "#fecdd3",
    "variable": "var(--colors-rose-200)"
  },
  "colors.rose.300": {
    "value": "#fda4af",
    "variable": "var(--colors-rose-300)"
  },
  "colors.rose.400": {
    "value": "#fb7185",
    "variable": "var(--colors-rose-400)"
  },
  "colors.rose.500": {
    "value": "#f43f5e",
    "variable": "var(--colors-rose-500)"
  },
  "colors.rose.600": {
    "value": "#e11d48",
    "variable": "var(--colors-rose-600)"
  },
  "colors.rose.700": {
    "value": "#be123c",
    "variable": "var(--colors-rose-700)"
  },
  "colors.rose.800": {
    "value": "#9f1239",
    "variable": "var(--colors-rose-800)"
  },
  "colors.rose.900": {
    "value": "#881337",
    "variable": "var(--colors-rose-900)"
  },
  "colors.rose.950": {
    "value": "#4c0519",
    "variable": "var(--colors-rose-950)"
  },
  "colors.fuchsia.50": {
    "value": "#fdf4ff",
    "variable": "var(--colors-fuchsia-50)"
  },
  "colors.fuchsia.100": {
    "value": "#fae8ff",
    "variable": "var(--colors-fuchsia-100)"
  },
  "colors.fuchsia.200": {
    "value": "#f5d0fe",
    "variable": "var(--colors-fuchsia-200)"
  },
  "colors.fuchsia.300": {
    "value": "#f0abfc",
    "variable": "var(--colors-fuchsia-300)"
  },
  "colors.fuchsia.400": {
    "value": "#e879f9",
    "variable": "var(--colors-fuchsia-400)"
  },
  "colors.fuchsia.500": {
    "value": "#d946ef",
    "variable": "var(--colors-fuchsia-500)"
  },
  "colors.fuchsia.600": {
    "value": "#c026d3",
    "variable": "var(--colors-fuchsia-600)"
  },
  "colors.fuchsia.700": {
    "value": "#a21caf",
    "variable": "var(--colors-fuchsia-700)"
  },
  "colors.fuchsia.800": {
    "value": "#86198f",
    "variable": "var(--colors-fuchsia-800)"
  },
  "colors.fuchsia.900": {
    "value": "#701a75",
    "variable": "var(--colors-fuchsia-900)"
  },
  "colors.fuchsia.950": {
    "value": "#4a044e",
    "variable": "var(--colors-fuchsia-950)"
  },
  "colors.violet.50": {
    "value": "#f5f3ff",
    "variable": "var(--colors-violet-50)"
  },
  "colors.violet.100": {
    "value": "#ede9fe",
    "variable": "var(--colors-violet-100)"
  },
  "colors.violet.200": {
    "value": "#ddd6fe",
    "variable": "var(--colors-violet-200)"
  },
  "colors.violet.300": {
    "value": "#c4b5fd",
    "variable": "var(--colors-violet-300)"
  },
  "colors.violet.400": {
    "value": "#a78bfa",
    "variable": "var(--colors-violet-400)"
  },
  "colors.violet.500": {
    "value": "#8b5cf6",
    "variable": "var(--colors-violet-500)"
  },
  "colors.violet.600": {
    "value": "#7c3aed",
    "variable": "var(--colors-violet-600)"
  },
  "colors.violet.700": {
    "value": "#6d28d9",
    "variable": "var(--colors-violet-700)"
  },
  "colors.violet.800": {
    "value": "#5b21b6",
    "variable": "var(--colors-violet-800)"
  },
  "colors.violet.900": {
    "value": "#4c1d95",
    "variable": "var(--colors-violet-900)"
  },
  "colors.violet.950": {
    "value": "#2e1065",
    "variable": "var(--colors-violet-950)"
  },
  "colors.sky.50": {
    "value": "#f0f9ff",
    "variable": "var(--colors-sky-50)"
  },
  "colors.sky.100": {
    "value": "#e0f2fe",
    "variable": "var(--colors-sky-100)"
  },
  "colors.sky.200": {
    "value": "#bae6fd",
    "variable": "var(--colors-sky-200)"
  },
  "colors.sky.300": {
    "value": "#7dd3fc",
    "variable": "var(--colors-sky-300)"
  },
  "colors.sky.400": {
    "value": "#38bdf8",
    "variable": "var(--colors-sky-400)"
  },
  "colors.sky.500": {
    "value": "#0ea5e9",
    "variable": "var(--colors-sky-500)"
  },
  "colors.sky.600": {
    "value": "#0284c7",
    "variable": "var(--colors-sky-600)"
  },
  "colors.sky.700": {
    "value": "#0369a1",
    "variable": "var(--colors-sky-700)"
  },
  "colors.sky.800": {
    "value": "#075985",
    "variable": "var(--colors-sky-800)"
  },
  "colors.sky.900": {
    "value": "#0c4a6e",
    "variable": "var(--colors-sky-900)"
  },
  "colors.sky.950": {
    "value": "#082f49",
    "variable": "var(--colors-sky-950)"
  },
  "colors.emerald.50": {
    "value": "#ecfdf5",
    "variable": "var(--colors-emerald-50)"
  },
  "colors.emerald.100": {
    "value": "#d1fae5",
    "variable": "var(--colors-emerald-100)"
  },
  "colors.emerald.200": {
    "value": "#a7f3d0",
    "variable": "var(--colors-emerald-200)"
  },
  "colors.emerald.300": {
    "value": "#6ee7b7",
    "variable": "var(--colors-emerald-300)"
  },
  "colors.emerald.400": {
    "value": "#34d399",
    "variable": "var(--colors-emerald-400)"
  },
  "colors.emerald.500": {
    "value": "#10b981",
    "variable": "var(--colors-emerald-500)"
  },
  "colors.emerald.600": {
    "value": "#059669",
    "variable": "var(--colors-emerald-600)"
  },
  "colors.emerald.700": {
    "value": "#047857",
    "variable": "var(--colors-emerald-700)"
  },
  "colors.emerald.800": {
    "value": "#065f46",
    "variable": "var(--colors-emerald-800)"
  },
  "colors.emerald.900": {
    "value": "#064e3b",
    "variable": "var(--colors-emerald-900)"
  },
  "colors.emerald.950": {
    "value": "#022c22",
    "variable": "var(--colors-emerald-950)"
  },
  "colors.lime.50": {
    "value": "#f7fee7",
    "variable": "var(--colors-lime-50)"
  },
  "colors.lime.100": {
    "value": "#ecfccb",
    "variable": "var(--colors-lime-100)"
  },
  "colors.lime.200": {
    "value": "#d9f99d",
    "variable": "var(--colors-lime-200)"
  },
  "colors.lime.300": {
    "value": "#bef264",
    "variable": "var(--colors-lime-300)"
  },
  "colors.lime.400": {
    "value": "#a3e635",
    "variable": "var(--colors-lime-400)"
  },
  "colors.lime.500": {
    "value": "#84cc16",
    "variable": "var(--colors-lime-500)"
  },
  "colors.lime.600": {
    "value": "#65a30d",
    "variable": "var(--colors-lime-600)"
  },
  "colors.lime.700": {
    "value": "#4d7c0f",
    "variable": "var(--colors-lime-700)"
  },
  "colors.lime.800": {
    "value": "#3f6212",
    "variable": "var(--colors-lime-800)"
  },
  "colors.lime.900": {
    "value": "#365314",
    "variable": "var(--colors-lime-900)"
  },
  "colors.lime.950": {
    "value": "#1a2e05",
    "variable": "var(--colors-lime-950)"
  },
  "colors.amber.50": {
    "value": "#fffbeb",
    "variable": "var(--colors-amber-50)"
  },
  "colors.amber.100": {
    "value": "#fef3c7",
    "variable": "var(--colors-amber-100)"
  },
  "colors.amber.200": {
    "value": "#fde68a",
    "variable": "var(--colors-amber-200)"
  },
  "colors.amber.300": {
    "value": "#fcd34d",
    "variable": "var(--colors-amber-300)"
  },
  "colors.amber.400": {
    "value": "#fbbf24",
    "variable": "var(--colors-amber-400)"
  },
  "colors.amber.500": {
    "value": "#f59e0b",
    "variable": "var(--colors-amber-500)"
  },
  "colors.amber.600": {
    "value": "#d97706",
    "variable": "var(--colors-amber-600)"
  },
  "colors.amber.700": {
    "value": "#b45309",
    "variable": "var(--colors-amber-700)"
  },
  "colors.amber.800": {
    "value": "#92400e",
    "variable": "var(--colors-amber-800)"
  },
  "colors.amber.900": {
    "value": "#78350f",
    "variable": "var(--colors-amber-900)"
  },
  "colors.amber.950": {
    "value": "#451a03",
    "variable": "var(--colors-amber-950)"
  },
  "colors.neutral.50": {
    "value": "var(--colors-gray-50)",
    "variable": "var(--colors-neutral-50)"
  },
  "colors.neutral.100": {
    "value": "var(--colors-gray-100)",
    "variable": "var(--colors-neutral-100)"
  },
  "colors.neutral.200": {
    "value": "var(--colors-gray-200)",
    "variable": "var(--colors-neutral-200)"
  },
  "colors.neutral.300": {
    "value": "var(--colors-gray-300)",
    "variable": "var(--colors-neutral-300)"
  },
  "colors.neutral.400": {
    "value": "var(--colors-gray-400)",
    "variable": "var(--colors-neutral-400)"
  },
  "colors.neutral.500": {
    "value": "var(--colors-gray-500)",
    "variable": "var(--colors-neutral-500)"
  },
  "colors.neutral.600": {
    "value": "var(--colors-gray-600)",
    "variable": "var(--colors-neutral-600)"
  },
  "colors.neutral.700": {
    "value": "var(--colors-gray-700)",
    "variable": "var(--colors-neutral-700)"
  },
  "colors.neutral.800": {
    "value": "var(--colors-gray-800)",
    "variable": "var(--colors-neutral-800)"
  },
  "colors.neutral.900": {
    "value": "var(--colors-gray-900)",
    "variable": "var(--colors-neutral-900)"
  },
  "colors.neutral.950": {
    "value": "var(--colors-gray-950)",
    "variable": "var(--colors-neutral-950)"
  },
  "colors.stone.50": {
    "value": "#fafaf9",
    "variable": "var(--colors-stone-50)"
  },
  "colors.stone.100": {
    "value": "#f5f5f4",
    "variable": "var(--colors-stone-100)"
  },
  "colors.stone.200": {
    "value": "#e7e5e4",
    "variable": "var(--colors-stone-200)"
  },
  "colors.stone.300": {
    "value": "#d6d3d1",
    "variable": "var(--colors-stone-300)"
  },
  "colors.stone.400": {
    "value": "#a8a29e",
    "variable": "var(--colors-stone-400)"
  },
  "colors.stone.500": {
    "value": "#78716c",
    "variable": "var(--colors-stone-500)"
  },
  "colors.stone.600": {
    "value": "#57534e",
    "variable": "var(--colors-stone-600)"
  },
  "colors.stone.700": {
    "value": "#44403c",
    "variable": "var(--colors-stone-700)"
  },
  "colors.stone.800": {
    "value": "#292524",
    "variable": "var(--colors-stone-800)"
  },
  "colors.stone.900": {
    "value": "#1c1917",
    "variable": "var(--colors-stone-900)"
  },
  "colors.stone.950": {
    "value": "#0c0a09",
    "variable": "var(--colors-stone-950)"
  },
  "colors.zinc.50": {
    "value": "#fafafa",
    "variable": "var(--colors-zinc-50)"
  },
  "colors.zinc.100": {
    "value": "#f4f4f5",
    "variable": "var(--colors-zinc-100)"
  },
  "colors.zinc.200": {
    "value": "#e4e4e7",
    "variable": "var(--colors-zinc-200)"
  },
  "colors.zinc.300": {
    "value": "#d4d4d8",
    "variable": "var(--colors-zinc-300)"
  },
  "colors.zinc.400": {
    "value": "#a1a1aa",
    "variable": "var(--colors-zinc-400)"
  },
  "colors.zinc.500": {
    "value": "#71717a",
    "variable": "var(--colors-zinc-500)"
  },
  "colors.zinc.600": {
    "value": "#52525b",
    "variable": "var(--colors-zinc-600)"
  },
  "colors.zinc.700": {
    "value": "#3f3f46",
    "variable": "var(--colors-zinc-700)"
  },
  "colors.zinc.800": {
    "value": "#27272a",
    "variable": "var(--colors-zinc-800)"
  },
  "colors.zinc.900": {
    "value": "#18181b",
    "variable": "var(--colors-zinc-900)"
  },
  "colors.zinc.950": {
    "value": "#09090b",
    "variable": "var(--colors-zinc-950)"
  },
  "colors.slate.50": {
    "value": "#f8fafc",
    "variable": "var(--colors-slate-50)"
  },
  "colors.slate.100": {
    "value": "#f1f5f9",
    "variable": "var(--colors-slate-100)"
  },
  "colors.slate.200": {
    "value": "#e2e8f0",
    "variable": "var(--colors-slate-200)"
  },
  "colors.slate.300": {
    "value": "#cbd5e1",
    "variable": "var(--colors-slate-300)"
  },
  "colors.slate.400": {
    "value": "#94a3b8",
    "variable": "var(--colors-slate-400)"
  },
  "colors.slate.500": {
    "value": "#64748b",
    "variable": "var(--colors-slate-500)"
  },
  "colors.slate.600": {
    "value": "#475569",
    "variable": "var(--colors-slate-600)"
  },
  "colors.slate.700": {
    "value": "#334155",
    "variable": "var(--colors-slate-700)"
  },
  "colors.slate.800": {
    "value": "#1e293b",
    "variable": "var(--colors-slate-800)"
  },
  "colors.slate.900": {
    "value": "#0f172a",
    "variable": "var(--colors-slate-900)"
  },
  "colors.slate.950": {
    "value": "#020617",
    "variable": "var(--colors-slate-950)"
  },
  "colors.transparent": {
    "value": "transparent",
    "variable": "var(--colors-transparent)"
  },
  "colors.gray.50": {
    "value": "#fcfcfc",
    "variable": "var(--colors-gray-50)"
  },
  "colors.gray.100": {
    "value": "#f8f9fa",
    "variable": "var(--colors-gray-100)"
  },
  "colors.gray.200": {
    "value": "#f7f7f9",
    "variable": "var(--colors-gray-200)"
  },
  "colors.gray.300": {
    "value": "#eceeef",
    "variable": "var(--colors-gray-300)"
  },
  "colors.gray.400": {
    "value": "#ced4da",
    "variable": "var(--colors-gray-400)"
  },
  "colors.gray.500": {
    "value": "#aaaaaa",
    "variable": "var(--colors-gray-500)"
  },
  "colors.gray.600": {
    "value": "#888888",
    "variable": "var(--colors-gray-600)"
  },
  "colors.gray.700": {
    "value": "#5a5a5a",
    "variable": "var(--colors-gray-700)"
  },
  "colors.gray.800": {
    "value": "#343a40",
    "variable": "var(--colors-gray-800)"
  },
  "colors.gray.900": {
    "value": "#212529",
    "variable": "var(--colors-gray-900)"
  },
  "colors.gray.950": {
    "value": "#212529",
    "variable": "var(--colors-gray-950)"
  },
  "colors.gray": {
    "value": "#aaaaaa",
    "variable": "var(--colors-gray)"
  },
  "colors.gray-v2.100": {
    "value": "#f8f9fa",
    "variable": "var(--colors-gray-v2-100)"
  },
  "colors.gray-v2.200": {
    "value": "#f7f7f9",
    "variable": "var(--colors-gray-v2-200)"
  },
  "colors.gray-v2.300": {
    "value": "#eaebf0",
    "variable": "var(--colors-gray-v2-300)"
  },
  "colors.gray-v2.400": {
    "value": "#d1d3da",
    "variable": "var(--colors-gray-v2-400)"
  },
  "colors.gray-v2.500": {
    "value": "#a1a3ab",
    "variable": "var(--colors-gray-v2-500)"
  },
  "colors.gray-v2.600": {
    "value": "#7a7d87",
    "variable": "var(--colors-gray-v2-600)"
  },
  "colors.gray-v2.700": {
    "value": "#4f535e",
    "variable": "var(--colors-gray-v2-700)"
  },
  "colors.gray-v2.800": {
    "value": "#363a45",
    "variable": "var(--colors-gray-v2-800)"
  },
  "colors.gray-v2.900": {
    "value": "#22242b",
    "variable": "var(--colors-gray-v2-900)"
  },
  "colors.gray-v2": {
    "value": "#a1a3ab",
    "variable": "var(--colors-gray-v2)"
  },
  "colors.blue.50": {
    "value": "#f0f7ff",
    "variable": "var(--colors-blue-50)"
  },
  "colors.blue.100": {
    "value": "#e0efff",
    "variable": "var(--colors-blue-100)"
  },
  "colors.blue.200": {
    "value": "#bdddff",
    "variable": "var(--colors-blue-200)"
  },
  "colors.blue.300": {
    "value": "#8fc5ff",
    "variable": "var(--colors-blue-300)"
  },
  "colors.blue.400": {
    "value": "#57a8ff",
    "variable": "var(--colors-blue-400)"
  },
  "colors.blue.500": {
    "value": "#007bff",
    "variable": "var(--colors-blue-500)"
  },
  "colors.blue.600": {
    "value": "#006fe6",
    "variable": "var(--colors-blue-600)"
  },
  "colors.blue.700": {
    "value": "#0063cc",
    "variable": "var(--colors-blue-700)"
  },
  "colors.blue.800": {
    "value": "#0051a8",
    "variable": "var(--colors-blue-800)"
  },
  "colors.blue.900": {
    "value": "#003670",
    "variable": "var(--colors-blue-900)"
  },
  "colors.blue.950": {
    "value": "#002752",
    "variable": "var(--colors-blue-950)"
  },
  "colors.blue": {
    "value": "#007bff",
    "variable": "var(--colors-blue)"
  },
  "colors.indigo.50": {
    "value": "#f9f5fe",
    "variable": "var(--colors-indigo-50)"
  },
  "colors.indigo.100": {
    "value": "#f0e7fe",
    "variable": "var(--colors-indigo-100)"
  },
  "colors.indigo.200": {
    "value": "#ddcafc",
    "variable": "var(--colors-indigo-200)"
  },
  "colors.indigo.300": {
    "value": "#c7a8fa",
    "variable": "var(--colors-indigo-300)"
  },
  "colors.indigo.400": {
    "value": "#a978f8",
    "variable": "var(--colors-indigo-400)"
  },
  "colors.indigo.500": {
    "value": "#6610f2",
    "variable": "var(--colors-indigo-500)"
  },
  "colors.indigo.600": {
    "value": "#5d0cdf",
    "variable": "var(--colors-indigo-600)"
  },
  "colors.indigo.700": {
    "value": "#530bc6",
    "variable": "var(--colors-indigo-700)"
  },
  "colors.indigo.800": {
    "value": "#4309a0",
    "variable": "var(--colors-indigo-800)"
  },
  "colors.indigo.900": {
    "value": "#300674",
    "variable": "var(--colors-indigo-900)"
  },
  "colors.indigo.950": {
    "value": "#220452",
    "variable": "var(--colors-indigo-950)"
  },
  "colors.indigo": {
    "value": "#6610f2",
    "variable": "var(--colors-indigo)"
  },
  "colors.purple.50": {
    "value": "#f6f3fb",
    "variable": "var(--colors-purple-50)"
  },
  "colors.purple.100": {
    "value": "#ede8f7",
    "variable": "var(--colors-purple-100)"
  },
  "colors.purple.200": {
    "value": "#d9cdef",
    "variable": "var(--colors-purple-200)"
  },
  "colors.purple.300": {
    "value": "#c1aee5",
    "variable": "var(--colors-purple-300)"
  },
  "colors.purple.400": {
    "value": "#a184d7",
    "variable": "var(--colors-purple-400)"
  },
  "colors.purple.500": {
    "value": "#6f42c1",
    "variable": "var(--colors-purple-500)"
  },
  "colors.purple.600": {
    "value": "#633ab1",
    "variable": "var(--colors-purple-600)"
  },
  "colors.purple.700": {
    "value": "#59349d",
    "variable": "var(--colors-purple-700)"
  },
  "colors.purple.800": {
    "value": "#432777",
    "variable": "var(--colors-purple-800)"
  },
  "colors.purple.900": {
    "value": "#301c54",
    "variable": "var(--colors-purple-900)"
  },
  "colors.purple.950": {
    "value": "#1e1236",
    "variable": "var(--colors-purple-950)"
  },
  "colors.purple": {
    "value": "#6f42c1",
    "variable": "var(--colors-purple)"
  },
  "colors.pink.50": {
    "value": "#fdf1f7",
    "variable": "var(--colors-pink-50)"
  },
  "colors.pink.100": {
    "value": "#fce8f2",
    "variable": "var(--colors-pink-100)"
  },
  "colors.pink.200": {
    "value": "#f9cde1",
    "variable": "var(--colors-pink-200)"
  },
  "colors.pink.300": {
    "value": "#f5adcf",
    "variable": "var(--colors-pink-300)"
  },
  "colors.pink.400": {
    "value": "#f084b7",
    "variable": "var(--colors-pink-400)"
  },
  "colors.pink.500": {
    "value": "#e83e8c",
    "variable": "var(--colors-pink-500)"
  },
  "colors.pink.600": {
    "value": "#df1b76",
    "variable": "var(--colors-pink-600)"
  },
  "colors.pink.700": {
    "value": "#c41768",
    "variable": "var(--colors-pink-700)"
  },
  "colors.pink.800": {
    "value": "#a41457",
    "variable": "var(--colors-pink-800)"
  },
  "colors.pink.900": {
    "value": "#6d0d3a",
    "variable": "var(--colors-pink-900)"
  },
  "colors.pink.950": {
    "value": "#4d0929",
    "variable": "var(--colors-pink-950)"
  },
  "colors.pink": {
    "value": "#e83e8c",
    "variable": "var(--colors-pink)"
  },
  "colors.red.50": {
    "value": "#fff7f5",
    "variable": "var(--colors-red-50)"
  },
  "colors.red.100": {
    "value": "#ffebe5",
    "variable": "var(--colors-red-100)"
  },
  "colors.red.200": {
    "value": "#ffd7cc",
    "variable": "var(--colors-red-200)"
  },
  "colors.red.300": {
    "value": "#ffbfad",
    "variable": "var(--colors-red-300)"
  },
  "colors.red.400": {
    "value": "#ff9f85",
    "variable": "var(--colors-red-400)"
  },
  "colors.red.500": {
    "value": "#ff7851",
    "variable": "var(--colors-red-500)"
  },
  "colors.red.600": {
    "value": "#ff5729",
    "variable": "var(--colors-red-600)"
  },
  "colors.red.700": {
    "value": "#f03400",
    "variable": "var(--colors-red-700)"
  },
  "colors.red.800": {
    "value": "#c72b00",
    "variable": "var(--colors-red-800)"
  },
  "colors.red.900": {
    "value": "#8f1f00",
    "variable": "var(--colors-red-900)"
  },
  "colors.red.950": {
    "value": "#701800",
    "variable": "var(--colors-red-950)"
  },
  "colors.red": {
    "value": "#ff7851",
    "variable": "var(--colors-red)"
  },
  "colors.orange.50": {
    "value": "#fff7f0",
    "variable": "var(--colors-orange-50)"
  },
  "colors.orange.100": {
    "value": "#ffeee1",
    "variable": "var(--colors-orange-100)"
  },
  "colors.orange.200": {
    "value": "#fed8b8",
    "variable": "var(--colors-orange-200)"
  },
  "colors.orange.300": {
    "value": "#fec495",
    "variable": "var(--colors-orange-300)"
  },
  "colors.orange.400": {
    "value": "#fea55d",
    "variable": "var(--colors-orange-400)"
  },
  "colors.orange.500": {
    "value": "#fd7e14",
    "variable": "var(--colors-orange-500)"
  },
  "colors.orange.600": {
    "value": "#ee6c02",
    "variable": "var(--colors-orange-600)"
  },
  "colors.orange.700": {
    "value": "#d46102",
    "variable": "var(--colors-orange-700)"
  },
  "colors.orange.800": {
    "value": "#ac4e01",
    "variable": "var(--colors-orange-800)"
  },
  "colors.orange.900": {
    "value": "#793701",
    "variable": "var(--colors-orange-900)"
  },
  "colors.orange.950": {
    "value": "#5b2901",
    "variable": "var(--colors-orange-950)"
  },
  "colors.orange": {
    "value": "#fd7e14",
    "variable": "var(--colors-orange)"
  },
  "colors.yellow.50": {
    "value": "#fffcf5",
    "variable": "var(--colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "#fff7e5",
    "variable": "var(--colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "#ffefcc",
    "variable": "var(--colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "#ffe5ad",
    "variable": "var(--colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "#ffda8a",
    "variable": "var(--colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "#ffce67",
    "variable": "var(--colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "#ffb10a",
    "variable": "var(--colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "#e69d00",
    "variable": "var(--colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "#bd8100",
    "variable": "var(--colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "#8a5e00",
    "variable": "var(--colors-yellow-900)"
  },
  "colors.yellow.950": {
    "value": "#664600",
    "variable": "var(--colors-yellow-950)"
  },
  "colors.yellow": {
    "value": "#ffce67",
    "variable": "var(--colors-yellow)"
  },
  "colors.green.50": {
    "value": "#f3fbf8",
    "variable": "var(--colors-green-50)"
  },
  "colors.green.100": {
    "value": "#e7f8f1",
    "variable": "var(--colors-green-100)"
  },
  "colors.green.200": {
    "value": "#c8eedf",
    "variable": "var(--colors-green-200)"
  },
  "colors.green.300": {
    "value": "#a9e5cd",
    "variable": "var(--colors-green-300)"
  },
  "colors.green.400": {
    "value": "#82d9b6",
    "variable": "var(--colors-green-400)"
  },
  "colors.green.500": {
    "value": "#56cc9d",
    "variable": "var(--colors-green-500)"
  },
  "colors.green.600": {
    "value": "#39bc88",
    "variable": "var(--colors-green-600)"
  },
  "colors.green.700": {
    "value": "#32a577",
    "variable": "var(--colors-green-700)"
  },
  "colors.green.800": {
    "value": "#298963",
    "variable": "var(--colors-green-800)"
  },
  "colors.green.900": {
    "value": "#1f6649",
    "variable": "var(--colors-green-900)"
  },
  "colors.green.950": {
    "value": "#154733",
    "variable": "var(--colors-green-950)"
  },
  "colors.green": {
    "value": "#56cc9d",
    "variable": "var(--colors-green)"
  },
  "colors.teal.50": {
    "value": "#edfcf8",
    "variable": "var(--colors-teal-50)"
  },
  "colors.teal.100": {
    "value": "#dcf9f1",
    "variable": "var(--colors-teal-100)"
  },
  "colors.teal.200": {
    "value": "#b0f2de",
    "variable": "var(--colors-teal-200)"
  },
  "colors.teal.300": {
    "value": "#7beac9",
    "variable": "var(--colors-teal-300)"
  },
  "colors.teal.400": {
    "value": "#2cdda8",
    "variable": "var(--colors-teal-400)"
  },
  "colors.teal.500": {
    "value": "#20c997",
    "variable": "var(--colors-teal-500)"
  },
  "colors.teal.600": {
    "value": "#1db487",
    "variable": "var(--colors-teal-600)"
  },
  "colors.teal.700": {
    "value": "#1aa37a",
    "variable": "var(--colors-teal-700)"
  },
  "colors.teal.800": {
    "value": "#158463",
    "variable": "var(--colors-teal-800)"
  },
  "colors.teal.900": {
    "value": "#0f6148",
    "variable": "var(--colors-teal-900)"
  },
  "colors.teal.950": {
    "value": "#0b4231",
    "variable": "var(--colors-teal-950)"
  },
  "colors.teal": {
    "value": "#20c997",
    "variable": "var(--colors-teal)"
  },
  "colors.cyan.50": {
    "value": "#f3fafc",
    "variable": "var(--colors-cyan-50)"
  },
  "colors.cyan.100": {
    "value": "#e7f5f8",
    "variable": "var(--colors-cyan-100)"
  },
  "colors.cyan.200": {
    "value": "#cfecf1",
    "variable": "var(--colors-cyan-200)"
  },
  "colors.cyan.300": {
    "value": "#b0dfe8",
    "variable": "var(--colors-cyan-300)"
  },
  "colors.cyan.400": {
    "value": "#90d2df",
    "variable": "var(--colors-cyan-400)"
  },
  "colors.cyan.500": {
    "value": "#6cc3d5",
    "variable": "var(--colors-cyan-500)"
  },
  "colors.cyan.600": {
    "value": "#45b4ca",
    "variable": "var(--colors-cyan-600)"
  },
  "colors.cyan.700": {
    "value": "#339db3",
    "variable": "var(--colors-cyan-700)"
  },
  "colors.cyan.800": {
    "value": "#2b8597",
    "variable": "var(--colors-cyan-800)"
  },
  "colors.cyan.900": {
    "value": "#1d5b67",
    "variable": "var(--colors-cyan-900)"
  },
  "colors.cyan.950": {
    "value": "#17464F",
    "variable": "var(--colors-cyan-950)"
  },
  "colors.cyan": {
    "value": "#6cc3d5",
    "variable": "var(--colors-cyan)"
  },
  "colors.cyan-v2.100": {
    "value": "#e3f4f7",
    "variable": "var(--colors-cyan-v2-100)"
  },
  "colors.cyan-v2.200": {
    "value": "#c3e7ee",
    "variable": "var(--colors-cyan-v2-200)"
  },
  "colors.cyan-v2.300": {
    "value": "#a8dce6",
    "variable": "var(--colors-cyan-v2-300)"
  },
  "colors.cyan-v2.400": {
    "value": "#88cfdd",
    "variable": "var(--colors-cyan-v2-400)"
  },
  "colors.cyan-v2.500": {
    "value": "#6cc3d5",
    "variable": "var(--colors-cyan-v2-500)"
  },
  "colors.cyan-v2.600": {
    "value": "#41b2c9",
    "variable": "var(--colors-cyan-v2-600)"
  },
  "colors.cyan-v2.700": {
    "value": "#3093a7",
    "variable": "var(--colors-cyan-v2-700)"
  },
  "colors.cyan-v2.800": {
    "value": "#236c7b",
    "variable": "var(--colors-cyan-v2-800)"
  },
  "colors.cyan-v2.900": {
    "value": "#184953",
    "variable": "var(--colors-cyan-v2-900)"
  },
  "colors.cyan-v2": {
    "value": "#6cc3d5",
    "variable": "var(--colors-cyan-v2)"
  },
  "colors.footer.font": {
    "value": "#235e4d",
    "variable": "var(--colors-footer-font)"
  },
  "colors.footer.background": {
    "value": "#9dd7c6",
    "variable": "var(--colors-footer-background)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--radii-xs)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--radii-xl)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--radii-2xl)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--radii-3xl)"
  },
  "radii.4xl": {
    "value": "2rem",
    "variable": "var(--radii-4xl)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--radii-full)"
  },
  "radii.sm": {
    "value": "0.3rem",
    "variable": "var(--radii-sm)"
  },
  "radii.md": {
    "value": "0.4rem",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "0.6rem",
    "variable": "var(--radii-lg)"
  },
  "radii.small": {
    "value": "0.25rem",
    "variable": "var(--radii-small)"
  },
  "radii.medium": {
    "value": "0.5rem",
    "variable": "var(--radii-medium)"
  },
  "radii.large": {
    "value": "1rem",
    "variable": "var(--radii-large)"
  },
  "radii.round": {
    "value": "50%",
    "variable": "var(--radii-round)"
  },
  "durations.fastest": {
    "value": "50ms",
    "variable": "var(--durations-fastest)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--durations-faster)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--durations-fast)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--durations-normal)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--durations-slow)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--durations-slower)"
  },
  "durations.slowest": {
    "value": "500ms",
    "variable": "var(--durations-slowest)"
  },
  "durations.sm": {
    "value": "0.2s",
    "variable": "var(--durations-sm)"
  },
  "durations.md": {
    "value": "0.4s",
    "variable": "var(--durations-md)"
  },
  "durations.lg": {
    "value": "0.6s",
    "variable": "var(--durations-lg)"
  },
  "borderWidths.sm": {
    "value": "1px",
    "variable": "var(--border-widths-sm)"
  },
  "borderWidths.md": {
    "value": "2px",
    "variable": "var(--border-widths-md)"
  },
  "borderWidths.lg": {
    "value": "3px",
    "variable": "var(--border-widths-lg)"
  },
  "fonts.sans": {
    "value": "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
    "variable": "var(--fonts-sans)"
  },
  "fonts.serif": {
    "value": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    "variable": "var(--fonts-serif)"
  },
  "fonts.mono": {
    "value": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    "variable": "var(--fonts-mono)"
  },
  "fonts.sourceSansPro": {
    "value": "var(--font-source-sans-pro, \"Source Sans Pro\"), sans-serif",
    "variable": "var(--fonts-source-sans-pro)"
  },
  "fonts.notoSans": {
    "value": "var(--font-noto-sans, \"NotoSans\"), sans-serif",
    "variable": "var(--fonts-noto-sans)"
  },
  "fonts.montserrat": {
    "value": "var(--font-montserrat, \"Montserrat\"), sans-serif",
    "variable": "var(--fonts-montserrat)"
  },
  "borders.none": {
    "value": "none",
    "variable": "var(--borders-none)"
  },
  "borders.default": {
    "value": "1px solid",
    "variable": "var(--borders-default)"
  },
  "borders.tooltip": {
    "value": "1px solid rgba(0, 0, 0, .15)",
    "variable": "var(--borders-tooltip)"
  },
  "breakpoints.2xl": {
    "value": "1536px",
    "variable": "var(--breakpoints-2xl)"
  },
  "breakpoints.sm": {
    "value": "576px",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "768px",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "992px",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1200px",
    "variable": "var(--breakpoints-xl)"
  },
  "colors.primary.50": {
    "value": "#f4faf9",
    "variable": "var(--colors-primary-50)"
  },
  "colors.primary.100": {
    "value": "#eaf5f2",
    "variable": "var(--colors-primary-100)"
  },
  "colors.primary.200": {
    "value": "#d1eae3",
    "variable": "var(--colors-primary-200)"
  },
  "colors.primary.300": {
    "value": "#b5ded2",
    "variable": "var(--colors-primary-300)"
  },
  "colors.primary.400": {
    "value": "#99d1c1",
    "variable": "var(--colors-primary-400)"
  },
  "colors.primary.500": {
    "value": "#78c2ad",
    "variable": "var(--colors-primary-500)"
  },
  "colors.primary.600": {
    "value": "#53b197",
    "variable": "var(--colors-primary-600)"
  },
  "colors.primary.700": {
    "value": "#479e86",
    "variable": "var(--colors-primary-700)"
  },
  "colors.primary.800": {
    "value": "#3b826e",
    "variable": "var(--colors-primary-800)"
  },
  "colors.primary.900": {
    "value": "#2b5f50",
    "variable": "var(--colors-primary-900)"
  },
  "colors.primary.950": {
    "value": "#20463b",
    "variable": "var(--colors-primary-950)"
  },
  "colors.primary": {
    "value": "var(--colors-primary-500)",
    "variable": "var(--colors-primary)"
  },
  "colors.secondary.50": {
    "value": "#fef6f6",
    "variable": "var(--colors-secondary-50)"
  },
  "colors.secondary.100": {
    "value": "#fce8e9",
    "variable": "var(--colors-secondary-100)"
  },
  "colors.secondary.200": {
    "value": "#fad6d8",
    "variable": "var(--colors-secondary-200)"
  },
  "colors.secondary.300": {
    "value": "#f8bfc2",
    "variable": "var(--colors-secondary-300)"
  },
  "colors.secondary.400": {
    "value": "#f6adb0",
    "variable": "var(--colors-secondary-400)"
  },
  "colors.secondary.500": {
    "value": "#f3969a",
    "variable": "var(--colors-secondary-500)"
  },
  "colors.secondary.600": {
    "value": "#eb5159",
    "variable": "var(--colors-secondary-600)"
  },
  "colors.secondary.700": {
    "value": "#d31821",
    "variable": "var(--colors-secondary-700)"
  },
  "colors.secondary.800": {
    "value": "#8e1016",
    "variable": "var(--colors-secondary-800)"
  },
  "colors.secondary.900": {
    "value": "#45080b",
    "variable": "var(--colors-secondary-900)"
  },
  "colors.secondary.950": {
    "value": "#250406",
    "variable": "var(--colors-secondary-950)"
  },
  "colors.secondary": {
    "value": "var(--colors-secondary-500)",
    "variable": "var(--colors-secondary)"
  },
  "colors.success.50": {
    "value": "var(--colors-green-50)",
    "variable": "var(--colors-success-50)"
  },
  "colors.success.100": {
    "value": "var(--colors-green-100)",
    "variable": "var(--colors-success-100)"
  },
  "colors.success.200": {
    "value": "var(--colors-green-200)",
    "variable": "var(--colors-success-200)"
  },
  "colors.success.300": {
    "value": "var(--colors-green-300)",
    "variable": "var(--colors-success-300)"
  },
  "colors.success.400": {
    "value": "var(--colors-green-400)",
    "variable": "var(--colors-success-400)"
  },
  "colors.success.500": {
    "value": "var(--colors-green-500)",
    "variable": "var(--colors-success-500)"
  },
  "colors.success.600": {
    "value": "var(--colors-green-600)",
    "variable": "var(--colors-success-600)"
  },
  "colors.success.700": {
    "value": "var(--colors-green-700)",
    "variable": "var(--colors-success-700)"
  },
  "colors.success.800": {
    "value": "var(--colors-green-800)",
    "variable": "var(--colors-success-800)"
  },
  "colors.success.900": {
    "value": "var(--colors-green-900)",
    "variable": "var(--colors-success-900)"
  },
  "colors.success.950": {
    "value": "var(--colors-green-950)",
    "variable": "var(--colors-success-950)"
  },
  "colors.success": {
    "value": "var(--colors-green-500)",
    "variable": "var(--colors-success)"
  },
  "colors.info.50": {
    "value": "var(--colors-cyan-50)",
    "variable": "var(--colors-info-50)"
  },
  "colors.info.100": {
    "value": "var(--colors-cyan-100)",
    "variable": "var(--colors-info-100)"
  },
  "colors.info.200": {
    "value": "var(--colors-cyan-200)",
    "variable": "var(--colors-info-200)"
  },
  "colors.info.300": {
    "value": "var(--colors-cyan-300)",
    "variable": "var(--colors-info-300)"
  },
  "colors.info.400": {
    "value": "var(--colors-cyan-400)",
    "variable": "var(--colors-info-400)"
  },
  "colors.info.500": {
    "value": "var(--colors-cyan-500)",
    "variable": "var(--colors-info-500)"
  },
  "colors.info.600": {
    "value": "var(--colors-cyan-600)",
    "variable": "var(--colors-info-600)"
  },
  "colors.info.700": {
    "value": "var(--colors-cyan-700)",
    "variable": "var(--colors-info-700)"
  },
  "colors.info.800": {
    "value": "var(--colors-cyan-800)",
    "variable": "var(--colors-info-800)"
  },
  "colors.info.900": {
    "value": "var(--colors-cyan-900)",
    "variable": "var(--colors-info-900)"
  },
  "colors.info.950": {
    "value": "var(--colors-cyan-950)",
    "variable": "var(--colors-info-950)"
  },
  "colors.info": {
    "value": "var(--colors-cyan-500)",
    "variable": "var(--colors-info)"
  },
  "colors.warning.50": {
    "value": "var(--colors-yellow-50)",
    "variable": "var(--colors-warning-50)"
  },
  "colors.warning.100": {
    "value": "var(--colors-yellow-100)",
    "variable": "var(--colors-warning-100)"
  },
  "colors.warning.200": {
    "value": "var(--colors-yellow-200)",
    "variable": "var(--colors-warning-200)"
  },
  "colors.warning.300": {
    "value": "var(--colors-yellow-300)",
    "variable": "var(--colors-warning-300)"
  },
  "colors.warning.400": {
    "value": "var(--colors-yellow-400)",
    "variable": "var(--colors-warning-400)"
  },
  "colors.warning.500": {
    "value": "var(--colors-yellow-500)",
    "variable": "var(--colors-warning-500)"
  },
  "colors.warning.600": {
    "value": "var(--colors-yellow-600)",
    "variable": "var(--colors-warning-600)"
  },
  "colors.warning.700": {
    "value": "var(--colors-yellow-700)",
    "variable": "var(--colors-warning-700)"
  },
  "colors.warning.800": {
    "value": "var(--colors-yellow-800)",
    "variable": "var(--colors-warning-800)"
  },
  "colors.warning.900": {
    "value": "var(--colors-yellow-900)",
    "variable": "var(--colors-warning-900)"
  },
  "colors.warning.950": {
    "value": "var(--colors-yellow-950)",
    "variable": "var(--colors-warning-950)"
  },
  "colors.warning": {
    "value": "var(--colors-yellow-500)",
    "variable": "var(--colors-warning)"
  },
  "colors.danger.50": {
    "value": "var(--colors-red-50)",
    "variable": "var(--colors-danger-50)"
  },
  "colors.danger.100": {
    "value": "var(--colors-red-100)",
    "variable": "var(--colors-danger-100)"
  },
  "colors.danger.200": {
    "value": "var(--colors-red-200)",
    "variable": "var(--colors-danger-200)"
  },
  "colors.danger.300": {
    "value": "var(--colors-red-300)",
    "variable": "var(--colors-danger-300)"
  },
  "colors.danger.400": {
    "value": "var(--colors-red-400)",
    "variable": "var(--colors-danger-400)"
  },
  "colors.danger.500": {
    "value": "var(--colors-red-500)",
    "variable": "var(--colors-danger-500)"
  },
  "colors.danger.600": {
    "value": "var(--colors-red-600)",
    "variable": "var(--colors-danger-600)"
  },
  "colors.danger.700": {
    "value": "var(--colors-red-700)",
    "variable": "var(--colors-danger-700)"
  },
  "colors.danger.800": {
    "value": "var(--colors-red-800)",
    "variable": "var(--colors-danger-800)"
  },
  "colors.danger.900": {
    "value": "var(--colors-red-900)",
    "variable": "var(--colors-danger-900)"
  },
  "colors.danger.950": {
    "value": "var(--colors-red-950)",
    "variable": "var(--colors-danger-950)"
  },
  "colors.danger": {
    "value": "var(--colors-red-500)",
    "variable": "var(--colors-danger)"
  },
  "colors.neutral": {
    "value": "var(--colors-gray-500)",
    "variable": "var(--colors-neutral)"
  },
  "colors.google": {
    "value": "#5379EC",
    "variable": "var(--colors-google)"
  },
  "colors.yahoo": {
    "value": "#7E1FFF",
    "variable": "var(--colors-yahoo)"
  },
  "colors.yahoo.hover": {
    "value": "#6513CF",
    "variable": "var(--colors-yahoo-hover)"
  },
  "colors.yahoo.active": {
    "value": "#4E09A5",
    "variable": "var(--colors-yahoo-active)"
  },
  "colors.fb": {
    "value": "#5b76a8",
    "variable": "var(--colors-fb)"
  },
  "colors.fb.light": {
    "value": "#0866FF",
    "variable": "var(--colors-fb-light)"
  },
  "colors.fb.active": {
    "value": "#0053DA",
    "variable": "var(--colors-fb-active)"
  },
  "spacing.-1": {
    "value": "calc(var(--spacing-1) * -1)",
    "variable": "var(--spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--spacing-2) * -1)",
    "variable": "var(--spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--spacing-3) * -1)",
    "variable": "var(--spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--spacing-4) * -1)",
    "variable": "var(--spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--spacing-5) * -1)",
    "variable": "var(--spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--spacing-6) * -1)",
    "variable": "var(--spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--spacing-7) * -1)",
    "variable": "var(--spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--spacing-8) * -1)",
    "variable": "var(--spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--spacing-9) * -1)",
    "variable": "var(--spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--spacing-10) * -1)",
    "variable": "var(--spacing-10)"
  },
  "spacing.-11": {
    "value": "calc(var(--spacing-11) * -1)",
    "variable": "var(--spacing-11)"
  },
  "spacing.-12": {
    "value": "calc(var(--spacing-12) * -1)",
    "variable": "var(--spacing-12)"
  },
  "spacing.-14": {
    "value": "calc(var(--spacing-14) * -1)",
    "variable": "var(--spacing-14)"
  },
  "spacing.-16": {
    "value": "calc(var(--spacing-16) * -1)",
    "variable": "var(--spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--spacing-20) * -1)",
    "variable": "var(--spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--spacing-24) * -1)",
    "variable": "var(--spacing-24)"
  },
  "spacing.-28": {
    "value": "calc(var(--spacing-28) * -1)",
    "variable": "var(--spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--spacing-32) * -1)",
    "variable": "var(--spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--spacing-36) * -1)",
    "variable": "var(--spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--spacing-40) * -1)",
    "variable": "var(--spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--spacing-44) * -1)",
    "variable": "var(--spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--spacing-48) * -1)",
    "variable": "var(--spacing-48)"
  },
  "spacing.-52": {
    "value": "calc(var(--spacing-52) * -1)",
    "variable": "var(--spacing-52)"
  },
  "spacing.-56": {
    "value": "calc(var(--spacing-56) * -1)",
    "variable": "var(--spacing-56)"
  },
  "spacing.-60": {
    "value": "calc(var(--spacing-60) * -1)",
    "variable": "var(--spacing-60)"
  },
  "spacing.-64": {
    "value": "calc(var(--spacing-64) * -1)",
    "variable": "var(--spacing-64)"
  },
  "spacing.-72": {
    "value": "calc(var(--spacing-72) * -1)",
    "variable": "var(--spacing-72)"
  },
  "spacing.-80": {
    "value": "calc(var(--spacing-80) * -1)",
    "variable": "var(--spacing-80)"
  },
  "spacing.-96": {
    "value": "calc(var(--spacing-96) * -1)",
    "variable": "var(--spacing-96)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--spacing-0\\.5) * -1)",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--spacing-1\\.5) * -1)",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--spacing-2\\.5) * -1)",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--spacing-3\\.5) * -1)",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.-4.5": {
    "value": "calc(var(--spacing-4\\.5) * -1)",
    "variable": "var(--spacing-4\\.5)"
  },
  "spacing.-5.5": {
    "value": "calc(var(--spacing-5\\.5) * -1)",
    "variable": "var(--spacing-5\\.5)"
  },
  "spacing.-full": {
    "value": "calc(var(--spacing-full) * -1)",
    "variable": "var(--spacing-full)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.50": {
    "value": "var(--colors-color-palette-50)",
    "variable": "var(--colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    "value": "var(--colors-color-palette-100)",
    "variable": "var(--colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--colors-color-palette-200)",
    "variable": "var(--colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--colors-color-palette-300)",
    "variable": "var(--colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--colors-color-palette-400)",
    "variable": "var(--colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--colors-color-palette-500)",
    "variable": "var(--colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--colors-color-palette-600)",
    "variable": "var(--colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    "value": "var(--colors-color-palette-700)",
    "variable": "var(--colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    "value": "var(--colors-color-palette-800)",
    "variable": "var(--colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    "value": "var(--colors-color-palette-900)",
    "variable": "var(--colors-color-palette-900)"
  },
  "colors.colorPalette.950": {
    "value": "var(--colors-color-palette-950)",
    "variable": "var(--colors-color-palette-950)"
  },
  "colors.colorPalette.font": {
    "value": "var(--colors-color-palette-font)",
    "variable": "var(--colors-color-palette-font)"
  },
  "colors.colorPalette.background": {
    "value": "var(--colors-color-palette-background)",
    "variable": "var(--colors-color-palette-background)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--colors-color-palette-hover)",
    "variable": "var(--colors-color-palette-hover)"
  },
  "colors.colorPalette.active": {
    "value": "var(--colors-color-palette-active)",
    "variable": "var(--colors-color-palette-active)"
  },
  "colors.colorPalette.light": {
    "value": "var(--colors-color-palette-light)",
    "variable": "var(--colors-color-palette-light)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar